import { IconButton } from '@mui/material';
import React, { ReactNode, useState } from 'react';

import { HelpDialog } from '~/components/HelpDialog/components/HelpDialog';

import { LegacyFAIcon, LegacyFAIcons } from '../LegacyFAIcon';

import { useSxStyles } from './useStyles';

type PropsType = {
  title: string;
  content: ReactNode;
  displayOnlyDialog?: boolean;
  onClose?: () => void;
};

// TODO: LegacyHelpDialog should be deprecated.
//  Update use cases to new design.
export const LegacyHelpDialog = (props: PropsType) => {
  const { title, content, displayOnlyDialog, onClose } = props;

  const sxStyles = useSxStyles();
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
    if (onClose) onClose();
  };

  return (
    <>
      {!displayOnlyDialog && (
        <IconButton
          onClick={() => setOpen(true)}
          sx={{ ...sxStyles.iconButton, ...sxStyles.help }}
        >
          <LegacyFAIcon FAIcon={LegacyFAIcons.QuestionMark} />
        </IconButton>
      )}
      {(open || displayOnlyDialog) && (
        <HelpDialog open={true} title={title} onClose={handleClose}>
          {content}
        </HelpDialog>
      )}
    </>
  );
};
